import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  ICategorySubCategoryMappingDetailResponse,
  ICategorySubCategoryMappingDetailResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useCategoryMappingDetailAPI = () => {
  const [categoryMappingDetail, setCategoryMappingDetail] = useState<ICategorySubCategoryMappingDetailResponseData>({
    category_id: "",
    category_name: "",
    sub_categories: [],
  });
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(INVENTORY_MODULE?.CATEGORY_MAPPING_DETAIL?.baseURL + `?category_id=${id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICategorySubCategoryMappingDetailResponse>) => {
            if (res.data.status === true) {
              setCategoryMappingDetail(res.data.data);
            } else {
              setCategoryMappingDetail(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        setCategoryMappingDetail(null);
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { execute, categoryMappingDetail };
};
